import { useEffect, useState } from 'react'
import coursera from 'assets/courseraIndicator.svg'
import courseraWithoutShadow from 'assets/courseraIndicatorWithoutShadow.svg'
import styles from './style.module.scss'

interface IProps {
  url: string | null | undefined
  origin:
    | 'HORIZONTAL_CARD'
    | 'VERTICAL_CARD'
    | 'COURSE_DETAIL'
    | 'MONITOR_COURSE_DETAIL'
    | 'TABLE'
}

const stylesByType = {
  HORIZONTAL_CARD: styles.horizontalCard,
  VERTICAL_CARD: styles.verticalCard,
  COURSE_DETAIL: styles.courseDetail,
  MONITOR_COURSE_DETAIL: styles.monitorCourseDetail,
  TABLE: styles.table,
}

export const ExternalCourseIndicator = ({ url, origin }: IProps) => {
  const [image, setImage] = useState('')
  const [show, setShow] = useState(false)

  const style = stylesByType[origin]

  const setCoursera = () => {
    switch (origin) {
      case 'TABLE':
        setImage(courseraWithoutShadow)
        break
      default:
        setImage(coursera)
        break
    }
    setShow(true)
  }

  useEffect(() => {
    setShow(false)
    if (url && url.includes('coursera')) setCoursera()
  }, [url])

  return show ? <img src={image} className={style} /> : <></>
}
